<script>
/* components */
import EmptyTable from '@/components/EmptyTable';
/* tools */
import { walletTableHead } from '@/scripts/mock';
import { humanizeDate } from '@/scripts/utils/time';

export default {
  name: 'RewardsTable',
  components: {
    EmptyTable,
  },
  props: {
    tableBody: {
      type: Array,
    },
  },
  data() {
    return {
      humanizeDate,
    };
  },
  computed: {},
  created() {
    this.tableHead = walletTableHead;
  },
  mounted() {},
  methods: {
    getValue(row, id) {
      switch (id) {
        case 'amount':
          return `${row[id]} ${row.token}`;
        case 'timestamp':
          return humanizeDate(row[id]);

        default:
          return row[id];
      }
    },
    getAmountClass(field, data) {
      const credit = data.direction === 'incoming';
      const color =
        field === 'amount' ? (credit ? 'positive' : 'negative') : null;

      const result = {
        data__value: true,
      };

      if (color) result[color] = true;

      return result;
    },
  },
};
</script>

<template>
  <div class="table-block">
    <div class="table-block__title">Rewards</div>
    <div class="table-block__table">
      <!-- table desktop-->
      <table class="table">
        <thead>
          <th
            v-for="{ id, name, width } in tableHead"
            :key="id"
            :style="[{ width: width + '%' }]"
          >
            {{ id }}
          </th>
        </thead>
        <!-- data table -->
        <tbody v-if="tableBody && tableBody.length">
          <!-- map row -->
          <tr v-for="row in tableBody" :key="row.id" class="row">
            <!-- map column -->
            <td v-for="{ id } in tableHead" :key="id">
              <div class="data">
                <div :class="getAmountClass(id, row)">
                  {{ getValue(row, id) }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <!-- // -->

        <EmptyTable v-else :columns="tableHead.length" />
      </table>

      <!-- mobile list card-->
      <div class="list" v-if="tableBody && tableBody.length">
        <div class="list__item" v-for="row in tableBody" :key="row.id">
          <div class="card">
            <div class="card__top">
              <div class="card__item">
                <div class="card__value">ID: {{ row.id }}</div>
              </div>
              <div class="card__item">
                <div class="card__value">
                  {{ humanizeDate(row.timestamp) }} |
                  <span
                    :class="[row.type === 'Withdraw' ? 'negative' : 'positive']"
                    >{{ row.type }}</span
                  >
                </div>
              </div>
            </div>
            <div class="card__middle">
              <div class="card__item">
                <div class="card__label">Game</div>
                <div class="card__value">
                  {{ row.game }}
                </div>
              </div>
              <div class="card__item">
                <div class="card__label">Amount</div>
                <div
                  class="card__value"
                  :class="[row.amountChange >= 0 ? 'positive' : 'negative']"
                >
                  {{ row.amount }}
                </div>
              </div>
            </div>
            <div class="card__bottom">
              <div class="card__label">Note</div>
              <div class="card__value">{{ row.notes }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- mobile empty block -->
      <table v-else class="mobile-empty">
        <EmptyTable :columns="tableHead.length" />
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.table-block {
  &__title {
    font-family: Poppins-Light;
    font-size: 21px;
    line-height: 29px;
    color: #ffffff;

    & + .table-block__table {
      margin-top: 10px;
    }
  }
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  thead {
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  }

  th {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    text-align: left;
    padding: 10px 20px;
    text-transform: capitalize;

    &:first-child {
      padding: 10px 0;
    }
  }

  .row {
    td {
      padding: 0;
    }

    td:first-child {
      .data {
        padding-left: 0;
      }
    }

    &:first-child {
      .data {
        margin-top: 10px;
      }
    }
  }
}

.data {
  min-height: 50px;
  display: flex;
  align-items: center;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  padding: 5px 20px;
  display: flex;
  align-items: center;

  &__value {
    &.positive {
      color: #38d5b8;
    }

    &.negative {
      color: #f95862;
    }
    span {
      font-size: 10px;
      color: #bcb5ff;
    }
  }
}

.card {
  border-radius: 16px;
  border: solid 1px #232e33;
  color: #ffffff;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding: 10px 15px;

    .card__value {
      font-size: 10px;
      line-height: 15px;

      span {
        color: #bcb5ff;
      }
    }
  }

  &__middle {
    padding: 15px 15px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-self: center;
  }

  &__bottom {
    padding: 9px 15px 15px;
  }

  &__value {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
  }

  &__label {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 10px;
  }

  &__item {
    width: 50%;

    & + & {
      text-align: right;
    }
  }

  .positive {
    color: #38d5b8 !important;
  }

  .negative {
    color: #f95862 !important;
  }
}

.list {
  width: 100%;
  display: none;
  flex-direction: column;
  align-items: center;

  &__item {
    width: 100%;
    max-width: 340px;

    & + & {
      margin-top: 20px;
    }
  }
}

.mobile-empty {
  width: 100%;
  display: none;
}

@media (max-width: $mobile) {
  .list {
    display: flex;
  }

  .table {
    display: none;
  }

  .table-block__title + .table-block__table {
    margin-top: 20px;
  }

  .mobile-empty {
    display: table;
  }
}
</style>
